import React from 'react';
import { FuelGridContainer, FuelGridItem } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import WhatsAppButton from '@components/ui/WhatsAppButton';
import useGlobals from '@hooks/useGlobals';
import useAmplitude from '@hooks/useAmplitude';
import LocationWithStatus from '@components/ui/Location/LocationWithStatus';
import TruckerLastLocation from '@components/ui/Trucker/TruckerLastLocation';
import { getTextToContactTruckerWhatsApp } from '@helpers/journeys/whatsappTalk';
import { handleTruncatedTextInSmallScreens } from '@utils/responsive';
import { ProposalPropsInterface } from './ProposalTypes';
import * as Styled from './ProposalStyles';
import ActionConfirmHiring from '../../ActionConfirmHiring';

function Proposal({
  trucker,
  origin,
  destination,
  hasBorder,
  id,
  created_by,
  onClick,
  onCallbackSentWhatsApp,
}: ProposalPropsInterface) {
  const { name, phone, lastLocation } = trucker;
  const { user } = useGlobals();
  const { amplitudeEvent } = useAmplitude();
  const messageWhatsApp = getTextToContactTruckerWhatsApp({
    truckerName: name.split(' ')[0] || '',
    companyName: user?.data?.company?.name || '',
    userName: user?.data?.name.split(' ')[0] || '',
    type: 'proposal',
    id,
  });

  return (
    <Styled.Wrapper hasBorder={hasBorder} onClick={(event) => onClick(event)}>
      <FuelGridContainer gapRow={32} style={{ columnGap: '16px' }}>
        <FuelGridItem sm={3} md={3} lg={4} xlg={4}>
          <TruckerLastLocation
            avatar={trucker.avatar}
            name={trucker.name}
            depositFee={trucker.depositFee}
            origin={origin}
            destination={destination}
          />
        </FuelGridItem>
        <FuelGridItem sm={3} md={3} lg={3} xlg={4}>
          <LocationWithStatus
            location={{
              cityName: handleTruncatedTextInSmallScreens(
                lastLocation.city_name,
                6,
              ),
              stateAcronym: lastLocation.state_acronym,
              updateAt: lastLocation.timestamp,
            }}
            status={{
              slug: created_by,
              updateAt: '',
            }}
          />
        </FuelGridItem>
        <FuelGridItem sm={4} md={3} lg={5} xlg={4}>
          <Styled.WrapperColumnActionProposal>
            <ActionConfirmHiring proposalId={id} createdBy={created_by} />

            {phone && (
              <FuelFlex
                defaultProps={{
                  alignItems: 'center',
                  gap: 'km1',
                  justifyContent: 'space-between',
                  customPadding: '0 36px 0 0 ',
                }}
              >
                <WhatsAppButton
                  phone={phone}
                  message={messageWhatsApp}
                  onCallbackSentWhatsApp={() => {
                    onCallbackSentWhatsApp?.({ id, truckerId: trucker.id });

                    amplitudeEvent('journey_whatsapp_for_trucker_sent', {
                      source: 'item-lista-proposta',
                      proposalId: id,
                      truckerId: trucker.id,
                    });
                  }}
                />
              </FuelFlex>
            )}
          </Styled.WrapperColumnActionProposal>
        </FuelGridItem>
      </FuelGridContainer>
    </Styled.Wrapper>
  );
}

export default Proposal;
